import React from "react";
import { observer } from "mobx-react";
//import { WIDGET_URL } from "../utils/constants";

const Embed = observer((props) => {
  // Declare a variable to hold the reference to the opened window
  //let newWindow = null;

  document.body.style.background = 'none';
/*
  const openChat = () => {
    if (newWindow && !newWindow.closed) {
      
      newWindow.focus();

    } else {
      const url = `${WIDGET_URL}${window.location.search}`;
      const windowName = "SSChat";
      const windowFeatures = "width=400,height=700,resizable=no,scrollbars=yes,toolbar=no,menubar=no,location=no,directories=no,status=no";
      
      newWindow = window.open(url, windowName, windowFeatures);

    }
  };
*/

  

  //src = `${src}?token=${window.inAppHelpOptions.token}&context=${window.inAppHelpOptions.context}&${sidsToQueryString(window.inAppHelpOptions?.sids)}&location=${encodeURIComponent(window.location.href)}`



  window.intercomSettings = {
      api_base: "https://api-iam.intercom.io",
      app_id: "sd1htz2y",
      user_id: 'Apple1234', // IMPORTANT: Replace "user.id" with the variable you use to capture the user's ID
      name: "Jason", // IMPORTANT: Replace "user.name" with the variable you use to capture the user's name
      email: 'jasonfill+apple1@gmail.com', // IMPORTANT: Replace "user.email" with the variable you use to capture the user's email address
      created_at: '2024-08-28', // IMPORTANT: Replace "user.createdAt" with the variable you use to capture the user's sign-up date
      Role: 'learner',
      Context: "proctor_account",
      company: {
          company_id: "AC1234567",
          created_at: 1394531169,
          name: "Demo Account"
        }
    };

  // We pre-filled your app ID in the widget URL: 'https://widget.intercom.io/widget/sd1htz2y'
  (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/sd1htz2y';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();



  return (
        <button type="button" class="btn rounded-pill me-2 btn-dark cursor-pointer" title="Help" id="help-button">
          <i className="menu-icon tf-icons ti ti-md ti-help"></i>
          Helpd
        </button>
  );
});

export default Embed;
